module.exports = __webpack_public_path__ + "static/media/hingeBottomImg2.d8170be2.png";